import BaseEcomServices from "./BaseEcomServices";
import BaseServices from "./BaseServices";

const OrderServices = {
    SyncOrder: async (postData) => {
        return await BaseServices.Post("/api/orders/sync-order", postData);
    },
    GetOrdersPage: async (paging) => {
        return await BaseServices.Post("/api/orders/get-orders", paging);
    },
    GetOrderPageCount: async (platform) => {
        return await BaseServices.Get(`/api/orders/get-orders-page-count/${platform}`);
    },
    GetOrderDetail: async (id) => {
        return await BaseServices.Get("/api/orders/orders-detail/" + id);
    },
    GetOrderDetailReturnModel: async (id) => {
        return await BaseServices.Get("/api/orders/get-order-detail-return-model/" + id);
    },
    PrePrintShippingLabel: async (orderId) => {
        return await BaseServices.Get(`/api/orders/pre-print-shipping-label?orderId=${orderId}`);
    },
    PrintShippingLabel: async (orderId, shippingCompanyId, shipModel = {}, shippingServiceType = 0) => {
        return await BaseServices.Post(`/api/orders/print-shipping-label?orderId=${orderId}&shippingCompanyId=${shippingCompanyId}&shippingServiceType=${shippingServiceType}`, shipModel);
    },
    CalculateShippingFee: async (orderId, shippingCompanyId) => {
        return await BaseServices.Post(`/api/orders/calculate-shipping-fee?orderId=${orderId}&shippingCompanyId=${shippingCompanyId}`, null);
    },
    PrintShippingLabelRanus: async (orderId, shippingCompanyId) => {
        return await BaseServices.Post(`/api/orders/print-shipping-label-ranus?orderId=${orderId}&shippingCompanyId=${shippingCompanyId}`);
    },
    SetStatusToReadyToShip: async (orderId) => {
        return await BaseServices.Post(`/api/orders/ready-to-ship/${orderId}`, null);
    },
    GetListOrderAffiliateInfo: async (paging) => {
        return await BaseServices.Post(`/api/orders/get-list-order-affiliate`, paging);
    },
    ChangeOrderStatus: async (orderId, status) => {
        return await BaseServices.Get(`/api/orders/change-order-status?id=${orderId}&status=${status}`);
    },
    ChangeMultiOrderStatus: async (orderIds, status) => {
        return await BaseServices.Post(`/api/orders/change-multi-order-status?status=${status}`, orderIds);
    },
    GetHandleOverToShipper: async (orderId) => {
        return await BaseServices.Get(`/api/orders/get-handleover-to-shipper?orderId=${orderId}`);
    },
    GetRanusShippingLabel: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/get-ranus-shipping-label?orderId=${orderId}`);
    },
    GetNextOrderStatus: async (status) => {
        return await BaseServices.Get(`/api/Orders/get-next-order-status/${status}`);
    },
    MomoRefund: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/momo-refund/${orderId}`);
    },
    UpdateOrderStatusById: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/update-order-status-by-id/${orderId}`);
    },
    VerifyOrderProduct: async (model) => {
        return await BaseServices.Post(`/api/Orders/verify-order-product`, model);
    },
    GetDesignModelByOrderProductId: async (orderProductId) => {
        return await BaseServices.Get(`/api/Orders/get-design-model-by-order-product-id/${orderProductId}`);
    },
    GetDesignExtendByOrderProductId: async (orderProductId) => {
        return await BaseServices.Get(`/api/Orders/get-design-extend-by-order-product-id/${orderProductId}`);
    },
    InsertRangeImageEnhance: async (models, designOrderId) => {
        return await BaseServices.Post(`/api/Orders/insert-range-image-enhance/${designOrderId}`, models);
    },
    RenderArtworkWithEnhanceUrl: async (orderProductId) => {
        return await BaseServices.Get(`/api/Orders/render-artwork-with-enhanceurl/${orderProductId}`);
    },
    GetOrderGrabDeliveryInfoById: async (shippingOrderNumber) => {
        return await BaseServices.Get(`/api/Orders/get-order-grab-delivery-info-by-id/${shippingOrderNumber}`);
    },
    GetLogisticBookingModels: async (paging) => {
        return await BaseServices.Post(`/api/Orders/get-logistic-booking-models`, paging);
    },
    CancelDelivery: async (deliveryId, shippingCompanyId) => {
        return await BaseServices.Get(`/api/Orders/cancel-delivery/${deliveryId}/${shippingCompanyId}`);
    },
    GetLogisticCountModels: async () => {
        return await BaseServices.Get(`/api/Orders/get-logistic-count-model`);
    },
    CancelOrderByAdmin: async (model) => {
        return await BaseServices.Post(`/api/Orders/cancel-order-by-admin`, model);
    },
    GetOrderPageCountModel: async (platform) => {
        return await BaseServices.Get(`/api/Orders/get-order-page-count-model/${platform}`);
    },
    GetLogisticBulkBookingModels: async (paging) => {
        return await BaseServices.Post(`/api/Orders/get-logistic-bulk-booking-models`, paging);
    },
    AllocateBulkBooking: async (models) => {
        return await BaseServices.Post(`/api/Orders/allocate-bulk-booking`, models);
    },
    GetOrderGrabDeliveryInfoByOrderId: async (listOrderId) => {
        return await BaseServices.Post(`/api/Orders/get-order-grab-delivery-info-by-order-id`, listOrderId);
    },
    CreateMultiOrder: async (listOrderId, shippingCompanyId, shippingServiceType) => {
        return await BaseServices.Post(`/api/Orders/create-multi-order/${shippingCompanyId}/${shippingServiceType}`, listOrderId);
    },
    GetMultiOrderGrabDeliveryInfo: async (sortingCode) => {
        return await BaseServices.Get(`/api/Orders/get-multi-order-info/${sortingCode}`);
    },
    GetOrderTupleByOrderNumber: async (orderNumber) => {
        return await BaseServices.Get(`/api/Orders/get-order-tuple-by-order-number/${orderNumber}`);
    },
    MarkIsConnect: async (orderId, isConnect) => {
        return await BaseServices.Get(`/api/Orders/mark-is-connect/${orderId}/${isConnect}`);
    },
    RemarkOrderByAdmin: async (model) => {
        return await BaseServices.Post(`/api/Orders/remark-order-by-admin`, model);
    },
    MarkIsBoom: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/mark-is-boom/${orderId}`);
    },
    RemoveIsBoom: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/remove-is-boom/${orderId}`);
    },
    CreateQRShare: async (orderId, transferAmount, token) => {
        return await BaseServices.Get(`/api/Orders/create-qr-share?orderId=${orderId}&transferAmount=${transferAmount}&token=${token}`);
    },
    GetOrderPlatformCountModels: async () => {
        return await BaseServices.Get(`/api/Orders/get-order-platform-count-models`);
    },
    CreateOrder: async (models) => {
        return await BaseEcomServices.Post("/api/Orders/create-order", models);
    },
    CreateUpdateListOrderPackageModel: async (models) => {
        return await BaseServices.Post("/api/Orders/create-update-list-order-package-model", models);
    },
    GetListOrderPackageModel: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/get-list-order-package-model/${orderId}`);
    },
    RemoveOrderPackage: async (id) => {
        return await BaseServices.Get(`/api/Orders/remove-order-package/${id}`);
    },
    GetOrderCustomizeSyncModel: async (orderProductId) => {
        return await BaseServices.Get(`/api/Orders/get-order-customize-sync-model/${orderProductId}`);
    },
    HandleSavePushingVariantExtends: async (model) => {
        return await BaseServices.Post(`/api/Orders/handle-save-pushing-variant-extends`, model);
    },
    GetPickProductModelsAsync: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/get-pick-product-models-async/${orderId}`);
    },
    UpdateOrderDetailRefund: async (model) => {
        return await BaseServices.Post(`/api/Orders/update-order-detail-refund`, model);
    },
    GetOrderReturnManageModels: async (paging) => {
        return await BaseServices.Post(`/api/Orders/get-order-return-manage-models`, paging);
    },
    GetOrderIdByWhetherOrderIdNumber: async (orderIdNumber) => {
        return await BaseServices.Get(`/api/Orders/get-order-id-by-whether-order-id-number/${orderIdNumber}`);
    },
    GetOrderReturnManageModelsById: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/get-order-return-manage-models-by-id/${orderId}`);
    },
    UpdateOrderReturnProduct: async (model) => {
        return await BaseServices.Post(`/api/Orders/update-order-return-product`, model);
    },
    HandlePrintLabelAndStorage: async (model) => {
        return await BaseServices.Post(`/api/Orders/handle-print-label-and-storage`, model);
    },
    GetOrderReturnProductManageModelsByStatus: async (paging) => {
        return await BaseServices.Post(`/api/Orders/get-order-return-product-manage-models-by-status`, paging);
    },
    GetOrderReturnBankDTOs: async (paging) => {
        return await BaseServices.Post(`/api/Orders/get-order-return-bank-dtos`, paging);
    },
    GetOrderReturnBankById: async (id) => {
        return await BaseServices.Get(`/api/Orders/get-order-return-bank-by-id/${id}`);
    },
    UpdateOrderReturnBankStatus: async (id, status) => {
        return await BaseServices.Get(`/api/Orders/update-order-return-bank-status/${id}/${status}`);
    },
};
export default OrderServices;
